import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { actionSetOperators } from 'lib/actions';
import { GET_OPERATORS } from 'lib/api/queries';

export const useRequestOperators = ({ skip = false } = {}) => {
  const dispatch = useDispatch();

  const setOperators = useCallback(
    (operators) => {
      dispatch(actionSetOperators(operators));
    },
    [dispatch]
  );

  return useQuery(GET_OPERATORS, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    skip,
    onCompleted: ({ Operator: operators }) => {
      setOperators(operators);
    },
  });
};
